<template>
  <section class="product-catalogs">
    <b-table
      :data="catalogs"
      :checked-rows.sync="checkedRows"
      :hoverable="true"
      :narrowed="true"
      :row-class="row => !row.status && 'has-text-grey-light'"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      :mobile-cards="false"
      checkable
      @check="onChecked"
    >
      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        width="95"
        style="vertical-align: middle"
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>

      <b-table-column
        field="catalog_no"
        :label="$t('attributes.catalog_code')"
        width="125"
        numeric
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.catalog_no }}
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        sortable
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>

      <template #empty>
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>{{ $t('attributes.empty') }}</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'TravelGroupCatalogsForm',

  props: {
    travelGroup: {
      required: true,
      type: Object
    },
    catalogs: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      sending: false,

      checkedRows: [],
      sortField: 'sort',
      sortOrder: 'asc',
      defaultSortOrder: 'asc'
    }
  },
  watch: {
    travelGroup(group) {
      this.updateCheckedRows(group, this.catalogs)
    },
    catalogs(value) {
      this.updateCheckedRows(this.travelGroup, value)
    }
  },
  mounted() {
    this.updateCheckedRows(this.travelGroup, this.catalogs)
  },
  methods: {
    updateCheckedRows(group, catalogs) {
      if (!group || !catalogs) {
        return { checkedRows: [] }
      }

      const catalogList = group.catalog_list
        ? group.catalog_list.split(',')
        : []

      this.checkedRows = catalogs.filter(catalog => {
        return catalogList.includes(catalog.catalog_no)
      })
    },
    async onChecked(checkedList) {
      if (checkedList.length === 0) {
        return notifyService.error('分類至少選擇一個！')
      }

      await this.onSend(checkedList)
    },
    async onSend(checkedList) {
      const api = `${TRAVEL_GROUPS_API}/${this.travelGroup.code}/catalogs`
      const data = {
        catalog_list: checkedList.map(c => c.catalog_no).join(',')
      }

      this.sending = true
      try {
        const res = await this.axios.put(api, data)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss">
.product-catalogs {
  tr.is-info {
    background-color: #f5f5f5;
    color: #363636;
  }
}
</style>
